import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { errorSideEffects, successSideEffects, updatingSideEffects } from "..";
import { toastGetError, Toastify } from "../../../components/Toaster";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../services/analytics/tracking";

export interface ScriptMutationState extends MutationTrackingState {
  Data?: any;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

const initialState: ScriptMutationState = {
  Data: null,
  isUpdating: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
};

const scriptMutationSlice = createSlice({
  name: "scriptMutations",
  initialState,
  reducers: {
    scriptMutationRequest(state, action: PayloadAction<any>) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    scriptMutationSuccess(state, action: PayloadAction<any>) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state, "success"));
      state.Data = action.payload;
      Toastify("success", "Script updated successfully.");
    },
    scriptMutationError(state, action: PayloadAction<string>) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state, "error"));
      state.errorMessage = action.payload;
      toastGetError(action.payload);
    }
  }
});

export const { scriptMutationRequest, scriptMutationSuccess, scriptMutationError } = scriptMutationSlice.actions;

export default scriptMutationSlice.reducer;
